import { NAVBAR } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'navbar_25',
  type: NAVBAR,
  name: 'Navbar 25',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/navbar/navbar_25.png',
  rootContent: {
    type: contentTypes.NAVBAR,
    properties: {
      backgroundColor: {type: 'css', value: '#F47822',editable: true},
      color: {type: 'css', value: 'white', editable: true},
      padding: {type: 'css', value: '0.5rem 1rem'},
      fontSize: {type: 'css', value: 'small', editable: true},
      logoSrc: {type: 'custom', value: '', editable: true},
      logoHeight: {type: 'custom', value: '3.5rem'},
      navItemActiveBorder: {type: 'custom', value: '#FAC493', editable: true},
      navItemBorderRadius: {type: 'custom', value: '50px', editable: true},
      navItemActiveBackground: {type: 'custom', value: '#F58E35'},
      navItemPadding: {type: 'custom', value: '0.5rem'},
      navItemMargin: {type: 'custom', value: '0rem 0.5rem'},
      navItemActiveBorderThickness: {type: 'custom', value:'1.5px', editable: true },
      logoPosition: {type: 'custom', value: 'middle'}


    },
    contents: []
  }
}
